import React,{useEffect,useState} from 'react'
import {Box,Typography,Button,Grid,Paper, CircularProgress, IconButton, Select, MenuItem, FormControl, InputLabel} from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../Components/Header'
import {useTheme,styled } from '@mui/material/styles'
import {useSelector, useDispatch} from 'react-redux';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import { ArrowBack, ArrowDropDownCircleOutlined, Edit, ScoreOutlined } from '@mui/icons-material';
import {Snackbar} from '@mui/material';
import ContentView from '../Components/ContentView';
import UserInput from "../Components/UserInput"
import CollapsibleTable from '../Components/CollapsibleTable';
import { add_reports } from '../Redux/reportsSlice';
import CandidateAssDialog from '../Components/CandidateAssDialog';
import AssessmentTable from '../Components/AssessmentTable';
import { add_candidates, delete_candidates } from '../Redux/settingSlice';

const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black",
	margin:20
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 30 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	height:100,
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginLeft: theme.spacing(1),
		marginBottom: theme.spacing(1),
	}
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
})); 

const CandidateDetail = ()=>{
	
	const test = useSelector(state => state?.templates.assessment);
	const data = useSelector(state => state?.reports.reports);
	const user = useSelector(state => state?.auth.user);
	const [rejecting,setRejecting] = useState(false)
	const [accepting,setAccepting] = useState(false)
	const navigate = useNavigate()
	const [expanded, setExpanded] = useState(false);
	const [open,setOpen] = useState(false)
	const [showModal,setShowModal] = useState(false)
	const [acceptedReports,setAcceptedReports] = useState(null)
	const [message,setMessage] = useState('')
	const dispatch = useDispatch()
	const [newData,setNewData] = useState(data)
	const [change,setChange] = useState(false)
	const [searching,setSearching] = useState(false)
	const [changing,setChanging] = useState(false)
	const [score,setScore] = useState(0)
	const [filterData,setFilterData] = useState("pending")

const handleChange = () => (event, newExpanded) => {
	setExpanded(newExpanded ? true : false);
};

const handleSnackbarClose = ()=>{
	setOpen(false)
}

async function handleFetchAll() {
	try{
		
		const send_data = {
			id:test.id
		}
	
	const handleSend = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-accepted/`,send_data,{
		headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
	}).catch(err=>{
		setMessage("error of connection,try later")
		setOpen(true)
	})
		
		if (handleSend?.data.success && handleSend.status == 200) {
			setAcceptedReports(handleSend?.data?.reports)
		}
	}catch(err){
		console.log(err)
	}
}

async function HandleReject() {
	try{
		setRejecting(true)

		const send_data = {
			id:test.id,
			score:parseInt(score),
			isAccepted:false,
			filt:filterData
		}
	
	const handleSend = await axios.put(`${process.env.REACT_APP_SERVER_AUTH_URL}set-selection/`,send_data,{
		headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
	}).catch(err=>{
		setMessage("error of connection,try later")
		setOpen(true)
		setRejecting(false)
	})
		
		if (handleSend?.data.success && handleSend.status == 200) {
			console.log(handleSend?.data)
			setMessage(handleSend?.data?.message)
			setOpen(true)
			setAcceptedReports(handleSend?.data?.reports?.filter(item=>item?.conclusion === "accept"))
			dispatch(add_reports(handleSend?.data?.reports))
			setRejecting(false)
		}else{
			setMessage(handleSend?.data?.message)
			setOpen(true)
			setRejecting(false)
		}
	}catch(err){
		console.log(err)
	}
}

async function HandleAccept() {
	try{
		setAccepting(true)

		const send_data = {
			id:test.id,
			score:parseInt(score),
			isAccepted:true,
			filt:filterData
		}
	
	const handleSend = await axios.put(`${process.env.REACT_APP_SERVER_AUTH_URL}set-selection/`,send_data,{
		headers:{
				"Content-Type":"application/json",
				"Authorization":`Bear ${user?.accessToken}`
			}
	}).catch(err=>{
		setMessage("error...check your connection and try later")
		setOpen(true)
		setAccepting(false)
	})
		
		if (handleSend?.data.success && handleSend.status == 200) {
			setMessage(handleSend?.data?.message)
			setOpen(true)
			setAcceptedReports(handleSend?.data?.reports?.filter(item=>item?.conclusion === "accept"))
			dispatch(add_reports(handleSend?.data?.reports))
			setAccepting(false)
		}else{
			setMessage(handleSend?.data?.message)
			setOpen(true)
			setAccepting(false)
		}
	}catch(err){
		console.log(err)
	}
}

async function get_data() {
try{
	
	setSearching(true)

	const send_data = {
		id:test.id,
		score:parseInt(score),
		filt:filterData ? filterData : 0
	}
	
	const getData = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-data/`,send_data,{
			headers:{
					"Content-Type":"application/json",
					"Authorization":`Bear ${user?.accessToken}`
				}
		}).catch(err=>{
			setSearching(false)
			setMessage("connection error")
			setOpen(true)
		}
		)
	
	if (getData?.data.success && getData.status == 200) {

		dispatch(add_reports(getData?.data?.data.reports))
		setNewData(getData?.data?.data.reports)
		setSearching(false)
	
	}
	}catch(err){
		console.log(err)
	}
}

useEffect(()=>{
(
	async ()=>{
		var app = []
		await dispatch(delete_candidates())

		const rep = newData?.filter(item=>item?.conclusion === "accept") || []

		for (let i = 0; i < rep?.length; i++) {
			
			const usr = {
				first_name:rep[i]?.first_name,
				last_name:rep[i]?.last_name,
				email:rep[i]?.email,
				hasTook:false,
				hasFinished:false,
				warning:null,
				isDisqualified:false,
				data:[]
			}

			app.push(usr)
			
		}
		await dispatch(add_candidates(app))
	}
)()
},[newData])

useEffect(()=>{
	handleFetchAll()
	get_data()
},[score,filterData])

useEffect(()=>{
if (test?.email !== user?.email) {
	navigate("/dashboard")
}
},[])

return(
	<Box style={{width:"100%",height:"100%"}}>
		<Header>
			<Breadcrumbs aria-label="breadcrumb">
				<Typography sx={{fontSize:12,color:"gray"}}> Dashboard </Typography>
				<Typography sx={{fontSize:12,color:"gray"}}>Assessment Report</Typography>
			</Breadcrumbs>			
		</Header>
		<Snackbar 
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}} 
			message={message} 
			onClose={handleSnackbarClose} 
			open={open} 
			autoHideDuration={2000}
		/>
		<Box display="flex" flexWrap="wrap" flexDirection="row" justifyContent="space-between" alignItems="center" sx={{width:"90%",marginLeft:2}}>
			<IconButton onClick={(e)=>{
				e?.preventDefault()
				navigate("/assessmentInfo")
			}}>
				<ArrowBack sx={{color:"gold"}} fontSize='small'/>
			</IconButton>
			<Box display="flex" flexWrap="wrap" flexDirection="row" justifyContent="flex-end" alignItems="center">
				<Button  onClick={(e)=>{
					e?.preventDefault()
					HandleAccept()
				}} disabled={accepting} sx={{background:"#fff",color:"#000",margin:1,fontFamily:"dinofans",fontSize:11}} variant="outlined">
					{
						accepting ? <CircularProgress sx={{color:"#000"}} size={15}/> : "Accept them"
					}
				</Button>
				<Button  onClick={(e)=>{
					e?.preventDefault()
					HandleReject()
				}} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:11}} variant="outlined">
					{
						rejecting ? <CircularProgress sx={{color:"#fff"}} size={15}/> : "Reject them"
					}
				</Button>
				<Button  onClick={(e)=>{
					e?.preventDefault()
					setShowModal(true)
				}} sx={{background:"gold",color:"#000",margin:1,fontFamily:"dinofans",fontSize:11}} variant="outlined">
					View accepted
				</Button>				
			</Box>

		</Box>
		<Box ml={3} sx={{display:"flex",flexDirection:"row",textAlign:"left"}}>
			<UserInput
				setInput={setScore}
				input={score}
				label="score"
			/>	
		</Box>
		<Box justifyContent="flex-start" alignItems="flex-start" width="30%" mt={1} ml={3}>
			<FormControl fullWidth>
				<InputLabel style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}} id="filter-label">Status</InputLabel>
				<Select
					labelId="filter-label"
					value={filterData}
					label="Status"
					sx={{height:45,fontSize:14}}
					onChange={(e)=>{
						setFilterData(e.target.value)
					}}
				>
					<MenuItem sx={{fontSize:13}} value="pending">pending</MenuItem>
					<MenuItem sx={{fontSize:13}} value="accept">accepted</MenuItem>
					<MenuItem sx={{fontSize:13}} value="fail">rejected</MenuItem>
				</Select>
			</FormControl>
		</Box>
		{
			searching && (
				<Box mt={1} ml={3} sx={{display:"flex",flexDirection:"row",textAlign:"left"}}>
					<CircularProgress size={20} sx={{color:"#fff"}}/>	
				</Box>
			)
		}
		<Box ml={2}>
			<Typography sx={{color:"white",padding:1,fontSize:12}}>
				{newData?.filter(item=>item?.conclusion === filterData )?.length} Total candidate(s) ( >= {score} % )
			</Typography>
		</Box>
		<AssessmentTable filterItem={filterData} setCandidate={setAcceptedReports}/>
		<CandidateAssDialog setNewData={setNewData} setCandidate={setAcceptedReports} data={acceptedReports} visible={showModal} setVisible={setShowModal}/>
	</Box>
	)
}

export default CandidateDetail